/** @format */

import React, { useContext, useState, useEffect } from "react";
import ListaCursosVirtual from "./Lista-cursos-virtual";
import { DataContext } from "../context/DataContext";
import Footer from "../components/Footer";

/* Begin By Javi */
import Header from "./Header";
import alertify from "alertifyjs";
import { Loader } from "../util/loader";
import { getStorage, getStorageList } from "../util/auth";
import utils from "./../util";
import CursoM from "./Movil/Curso-m";
import { apiCursos } from "../api";
import { left } from "@popperjs/core";
/* End By Javi */
let codigo = 0;
const { isMobile } = utils;
function ActiveSlider_PG(_isMobile) {
  let URLactual = window.location;

  let home = document.getElementById("home");
  let curso = document.getElementById("curso");
  let horario = document.getElementById("horarios");
  let pagos = document.getElementById("pagos");
  let historial = document.getElementById("historial");
  if (home.classList.contains("active-menu")) {
    home.classList.remove("active-menu");
  }
  if (curso.classList.contains("active-menu")) {
    curso.classList.remove("active-menu");
  }
  if (horario.classList.contains("active-menu")) {
    horario.classList.remove("active-menu");
  }
  if (pagos.classList.contains("active-menu")) {
    pagos.classList.remove("active-menu");
  }
  if (historial.classList.contains("active-menu")) {
    historial.classList.remove("active-menu");
  }

  if (URLactual.pathname == "/home") {
    home.classList.add("active-menu");
  } else if (URLactual.pathname == "/curso") {
    curso.classList.add("active-menu");
  } else if (URLactual.pathname == "/horarios") {
    horario.classList.add("active-menu");
  } else if (URLactual.pathname == "/pagos") {
    pagos.classList.add("active-menu");
  } else if (URLactual.pathname == "/historial-academico") {
    historial.classList.add("active-menu");
  }
  if (_isMobile) {
    let instalar = document.getElementById("instalar");
    if (instalar.classList.contains("active-menu")) {
      instalar.classList.remove("active-menu");
    }
    if (URLactual.pathname == "/Como-instalar") {
      instalar.classList.add("active-menu");
    }
  }
}
export const Cursos = () => {
  /* Begin By Javi */
  const [_isMobile] = useState(isMobile());
  const [Loading, setloading] = useState(true);
  let dataStorage = getStorage("studientActive");
  let dataListStorage = getStorageList("studientList");
  const alertMessage = "Notificación de Cursos";
  /* End By Javi */
  const { data, setData } = useContext(DataContext);
  const [lisCursos, setLisCursos] = useState([]);

  const ActiveAlummno = () => {
    setloading(true);
    codigo =
      data == undefined || data.student == undefined
        ? dataStorage.Codigo
        : data.student.Codigo;
    const promise = apiCursos.listar(codigo, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        setLisCursos(res);
      }
    });
  };

  useEffect(() => {
    ActiveSlider_PG(_isMobile);
  
    setData({
      ...data,
      students: dataListStorage,
      student: dataStorage,
    });
  
   if (dataStorage.Codigo == undefined || data == undefined && (dataListStorage!= undefined && dataListStorage.length != 1)) {
      setloading(false);
      alertify
        .alert("Debe seleccionar un Estudiante", function () {
          window.location.href = "./home";
        })
        .setHeader(alertMessage);
      return;
    }
  
    ActiveAlummno();
  }, [setData, setLisCursos]);
  
  return (
    <div>
      {Loader(Loading)}
      <div className="contend">
        <div className="text">
          <div className={"col-12"}>
            {data != undefined && data.student != undefined ? (
              <Header
                objData={data}
                redir={"./home"}
                Title={"Cursos"}
                objActiveAlummno={ActiveAlummno}
                isMobile={_isMobile}
              />
            ) : (
              ""
            )}
            {_isMobile ? (
              data != undefined ? (
                <div className="contend-movil">
                  <CursoM objlisCursos={lisCursos} objdata={data.student} />
                </div>
              ) : (
                ""
              )
            ) : (
              <div className=" mt-4">
                <div className="row mb-1">
                  <div className="col align-self-start"></div>
                  <div className="col align-self-center"></div>
                  <div className="row col align-self-end">
                    <div className="row col-6">
                      <div className="leyenda-virtual"></div>
                      <div>
                        <h1 className="leyenda-text">VIRTUAL</h1>
                      </div>
                    </div>
                    <div className="row col-6">
                      <div className="leyenda-presencial"></div>
                      <div>
                        <h1 className="leyenda-text">PRESENCIAL</h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: "1.8ex" }}>
                  <div
                    className="background-sub-cursos text-card head-apagarv2"
                    style={{ alignItems: "center", padding: "0.65% 0" }}
                  >
                    <div className=" columna-0" style={{ textAlign: left }}>
                      <div>Mis Cursos</div>
                    </div>
                    <div className=" columna-2">
                      <div className="nav-link">Faltas</div>
                    </div>
                    <div className=" columna-3">
                      <div className="nav-link mr-2">Créditos</div>
                    </div>
                    <div className=" columna-4">
                      <div className="nav-link mr-2">Ciclo</div>
                    </div>
                    <div className=" columna-5">
                      <div className="nav-link ">Notas</div>
                    </div>
                    <div className=" columna-6">
                      <div className="nav-link ">Tipo Curso</div>
                    </div>
                    <div className="columna-7 ">
                      <div className="nav-link ">Avance Promedio</div>
                    </div>
                    <div className="columna-8"></div>
                  </div>
                  {/* <div className="background-cursos col-12">
                    <div className="row">
                      <div className="col-4 mr-2">
                        <h1
                          className="navbar-brand"
                          style={{ fontWeight: "bold" }}
                        >
                          MIS CURSOS
                        </h1>
                      </div>
                      <ul className="nav">
                        <li className="nav-item ml-2 ">
                          <h6 className="nav-link">Faltas</h6>
                        </li>
                        <li className="nav-item ml-4">
                          <h6 className="nav-link mr-2">Créditos</h6>
                        </li>
                        <li className="nav-item ml-3 mr-2">
                          <h6 className="nav-link mr-2">Ciclo</h6>
                        </li>
                        <li className="nav-item ml-4 mr-1">
                          <h6 className="nav-link ">Notas</h6>
                        </li>
                        <li className="nav-item ml-4">
                          <h6 className="nav-link ">Tipo Curso</h6>
                        </li>
                        <li className="nav-item">
                          <h6 className="nav-link ">
                            Avance de Promedio Final
                          </h6>
                        </li>
                      </ul>
                    </div>
                  </div> */}
                </div>
                {lisCursos != undefined &&
                lisCursos != null &&
                lisCursos.length != 0 ? (
                  lisCursos.map((cursos, i) => {
                    return (
                      <ListaCursosVirtual
                        objCursos={cursos}
                        objStudent={data.student}
                      />
                    );
                  })
                ) : (
                  <div style={{ textAlign: "center" }}>
                    No existen Cursos...
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
